import { TablePagination as Pagination } from "@mui/material";

export function TablePagination({ count, setSkip, skip, take, setTake }: any) {

    const handleChangePage = (
        event: any,
        newPage: number,
    ) => {
        setSkip(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setTake(parseInt(event.target.value, 10));
        setSkip(0);
    };

    return (
        <Pagination
            component="div"
            count={count}
            page={skip}
            onPageChange={handleChangePage}
            rowsPerPage={take}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    );
}
